import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AmApiKeyService } from '@core/services/am-api-key.service';

@Injectable()
export class AmApiKeyInterceptor implements HttpInterceptor {
  constructor(private amKey: AmApiKeyService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const key = this.amKey.isEnabled() ? this.amKey.getKey() : null;
    if (!key) {
      return next.handle(req);
    }

    const cloned = req.clone({
      setHeaders: {
        'X-AUTH-TOKEN': key,
      },
    });
    return next.handle(cloned);
  }
}
